export default __webpack_public_path__ + "src/assets/approval.1ed3ee940c2ae203ec9ffb6eff70ff4c.svg";